module.exports = __webpack_public_path__ + "static/media/Simpel Komplit Web Banner-04.5164c9ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/component/img/large/Simpel Komplit Web Banner-04.jpg
// module id = 980
// module chunks = 2